import { Component, OnInit, Input, ViewChild, EventEmitter, Output } from '@angular/core';
import { MatAccordion } from '@angular/material/expansion';
import { SchedulerRuleService } from '../service/scheduler.rule.service';
import { TranslateService } from '@ngx-translate/core';
import { NgForm } from '@angular/forms';

@Component({
	selector: 'app-service-scheduler-rule',
	templateUrl: './rule.component.html',
	styleUrls: ['./rule.component.scss']
})
export class SchedulerRuleComponent implements OnInit {

	_rule: any;

	@Input() set rule(_rule: any) {
		this._rule = _rule;

		this.initRule(_rule);
	}
	get rule() {
		return this._rule;
	}

	@Output() updated = new EventEmitter<any>();

	range = 'Once';
	weekday = [];
	hourOfDays = [];
	endOfMonth = false;

	applyFrom: any;
	applyTo: any;

	@ViewChild(MatAccordion, { static: true }) accordion: MatAccordion;
	
	@ViewChild('ruleForm', {static: true}) private ruleForm: NgForm;


	constructor(
		private ruleService: SchedulerRuleService,
		private translateService: TranslateService
	) { }

	ngOnInit() {
		this.initRule();
	}

	initRule(rule?: any) {
		if (rule) {
			if (!rule.state) {
				rule.state = 'Active';
			}

			if (rule.applyFrom && rule.applyTo) {
				this.range = 'Range';
			} else {
				this.range = 'Once';
			}
			
			if (!rule.repeatDayType) {
				rule.repeatDayType = 'None';
			}
			if (!rule.repeatHourType) {
				rule.repeatHourType = 'None';
			}
			rule.applyMinute1 = rule.applyMinute2 = rule.applyMinute;
			rule.applyDate = rule.applyFrom;

			if (rule.applyFrom) {
				rule.applyDate = rule.applyFrom = new Date(rule.applyFrom);
			}
			if (rule.applyTo) {
				rule.applyTo = new Date(rule.applyTo);
				this.range = 'Range';
			}
		}

		this.hourOfDays = [];
		for (let index = 0; index < 24; index ++) {
			const hourOfDay = {
				name: (index < 10 ? '0' + index : "" + index),
				value: false
			};

			if (rule && rule.applyHourOfDay && rule.applyHourOfDay.includes('H' + hourOfDay.name)) {
				hourOfDay.value = true;
			}

			this.hourOfDays.push(hourOfDay);
		}

		this.weekday = [];
		for (let index = 0; index < 7; index ++) {
			let state = false;
			if (rule && rule.applyDayOfWeek) {
				if (index == 0 && rule.applyDayOfWeek.indexOf('SUN') !== -1) {
					state = true;
				} else if (index == 1 && rule.applyDayOfWeek.indexOf('MON') !== -1) {
					state = true;
				} else if (index == 2 && rule.applyDayOfWeek.indexOf('TUE') !== -1) {
					state = true;
				} else if (index == 3 && rule.applyDayOfWeek.indexOf('WED') !== -1) {
					state = true;
				} else if (index == 4 && rule.applyDayOfWeek.indexOf('THR') !== -1) {
					state = true;
				} else if (index == 5 && rule.applyDayOfWeek.indexOf('FRI') !== -1) {
					state = true;
				} else if (index == 6 && rule.applyDayOfWeek.indexOf('SAT') !== -1) {
					state = true;
				}
			}
			this.weekday.push(state);
		}

		if (rule && rule.repeatDayType === 'Month' && !rule.applyDayOfMonth) {
			this.endOfMonth = true;
		}

		if (this.accordion) {
			setTimeout(() => {
				this.accordion.openAll();
			}, 100);
		}
	}

	onRangeTypeChanged($event) {
		if ($event.value === 'Range') {
			this.rule.applyFrom = this.rule.applyDate;
			if (!this.rule.applyTo) {
				this.rule.applyTo = this.rule.applyFrom;
			}
		} else {
			this.rule.applyDate = this.rule.applyFrom;
		}
	}

	doDelete() {
		if (this.rule.id) {
			this.translateService.get('service.scheduler.rule.confirm.delete').subscribe((message: string) => {
				if (confirm(message)) {
					this.ruleService.delete(this.rule.id).subscribe(() => {
						this.updated.emit({});
					});
				}
			});
		} else {
			this.translateService.get('service.scheduler.rule.alert.missing-delete-rule').subscribe((message: string) => {
				alert(message);
			});
			return;
		}
	}

	doSave() {
		if (!this.ruleForm.valid) {
			this.translateService.get('common.invalid.alert').subscribe((message: string) => {
				alert(message);
				if (this.ruleForm.controls) {
					for (const control in this.ruleForm.controls) {
						this.ruleForm.controls[control].markAsTouched();
					}
				}
			});
			return;
		} else {
			if (!this.rule.name) {
				this.translateService.get('service.scheduler.rule.alert.missing-name').subscribe((message: string) => {
					alert(message);
				});
				return;
			} else if (!this.rule.applyFrom && !this.rule.applyDate) {
				this.translateService.get('service.scheduler.rule.alert.missing-apply-from').subscribe((message: string) => {
					alert(message);
				});
				return;
			}
	
			let applyFrom: Date;
			let applyTo: Date;
	
			if (this.range === 'Once') {
				if (this.rule.applyDate.year) {
					applyFrom = new Date(this.rule.applyDate.years(), this.rule.applyDate.month(), this.rule.applyDate.date());
				} else {
					applyFrom = this.rule.applyDate;
				}
			} else if (this.range === 'Range' && this.rule.repeatDayType === 'None') {
				if (this.rule.applyFrom.year) {
					applyFrom = new Date(this.rule.applyFrom.years(), this.rule.applyFrom.month(), this.rule.applyFrom.date());
				} else {
					applyFrom = this.rule.applyFrom;
				}
				if (this.rule.applyTo.year) {
					applyTo = new Date(this.rule.applyTo.years(), this.rule.applyTo.month(), this.rule.applyTo.date());
				} else {
					applyTo = this.rule.applyTo;
				}
			} else if (this.rule.repeatDayType !== 'None') {
				if (!this.rule.applyTo) {
					this.translateService.get('service.scheduler.rule.alert.missing-apply-to').subscribe((message: string) => {
						alert(message);
					});
					return;
				} else {
					if (this.rule.applyFrom.year) {
						applyFrom = new Date(this.rule.applyFrom.year(), this.rule.applyFrom.month(), this.rule.applyFrom.date());
					} else {
						applyFrom = this.rule.applyFrom;
					}
					if (this.rule.applyTo.year) {
						applyTo = new Date(this.rule.applyTo.year(), this.rule.applyTo.month(), this.rule.applyTo.date());
					} else {
						applyTo = this.rule.applyTo;
					}
					if (this.rule.repeatDayType === 'Week') {
						const applyDayOfWeek = [];
						if (this.weekday[0]) applyDayOfWeek.push('SUN');
						if (this.weekday[1]) applyDayOfWeek.push('MON');
						if (this.weekday[2]) applyDayOfWeek.push('TUE');
						if (this.weekday[3]) applyDayOfWeek.push('WED');
						if (this.weekday[4]) applyDayOfWeek.push('THR');
						if (this.weekday[5]) applyDayOfWeek.push('FRI');
						if (this.weekday[6]) applyDayOfWeek.push('SAT');

						if (applyDayOfWeek.length === 0) {
							this.translateService.get('service.scheduler.rule.alert.missing-day-of-week').subscribe((message: string) => {
								alert(message);
							});
							return;
						} else {
							this.rule.applyDayOfWeek = applyDayOfWeek;
						}
					} else if (this.rule.repeatType === 'Month') {
						if (this.endOfMonth) {
							this.rule.applyDayOfMonth = 0;
						} else if (!this.rule.applyDayOfMonth) {
							this.translateService.get('service.scheduler.rule.alert.missing-day-of-month').subscribe((message: string) => {
								alert(message);
							});
							return;
						}
					}  
				}
			}
	
			if (this.range === 'Once') {
				this.rule.applyTo = null;
				this.rule.applyFrom = applyFrom;
				this.rule.repeatDayType = 'None';
			}
	
			if (this.rule.repeatHourType === 'Hour') {
				const applyHourOfDay = [];
				for (let index = 0; index < 24; index ++) {
					if (this.hourOfDays[index].value) {
						if (index < 10) {
							applyHourOfDay.push('H0' + index);
						} else {
							applyHourOfDay.push('H' + index);
						}
					}
				}
				if (applyHourOfDay.length === 0) {
					this.translateService.get('service.scheduler.rule.alert.missing-hour-of-day').subscribe((message: string) => {
						alert(message);
					});
					return;
				} else {
					this.rule.applyHourOfDay = applyHourOfDay;
				}
			} else {
				if (typeof this.rule.applyHour === 'undefined' || this.rule.applyHour === null) {
					this.translateService.get('service.scheduler.rule.alert.missing-apply-hour').subscribe((message: string) => {
						alert(message);
					});
					return;
				}
			}
			if ((!this.rule.applyMinute1 && this.rule.applyMinute1 !== 0) && (!this.rule.applyMinute2 && this.rule.applyMinute2 !== 0)) {
				this.translateService.get('service.scheduler.rule.alert.missing-apply-minute').subscribe((message: string) => {
					alert(message);
				});
				return;
			} else {
				if (this.rule.repeatHourType === 'Hour') {
					this.rule.applyMinute = this.rule.applyMinute2;
				} else {
					this.rule.applyMinute = this.rule.applyMinute1;
				}
			}
	
			this.translateService.get(['service.scheduler.rule.confirm.save', 'service.scheduler.rule.alert.saved']).subscribe((messages: string[]) => {
				if (confirm(messages['service.scheduler.rule.confirm.save'])) {
					const setting = JSON.parse(JSON.stringify(this.rule));
	
					if (applyFrom) {
						applyFrom.setHours(applyFrom.getHours() - applyFrom.getTimezoneOffset() / 60);
					}
					if (applyTo) {
						applyTo.setHours(applyTo.getHours() - applyTo.getTimezoneOffset() / 60);
					}
					setting.applyDate = applyFrom;
					setting.applyFrom = applyFrom;
					setting.applyTo = applyTo;
					this.ruleService.save(this.rule.id, setting).subscribe((rule: any) => {
						alert(messages['service.scheduler.rule.alert.saved']);
						this.updated.emit(rule);
					});    
				}
			});	
		}
	}
}
